import * as actions from "../actions/actionTypes/index";

const StandartGamesReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.STANDART_GAMES_LIST_UPDATE_RECEIVED:
            return {
                ...state,
                [action.key]: {
                    ...state[action.key],
                    ...action.payload
                }
            };
        case actions.RESET_STANDART_GAMES_LIST:
            return action.key
                ? {
                    [action.key]: undefined
                }
                : {

                };
        default :
            return state;
    }
};

export default StandartGamesReducer;
